import { render, staticRenderFns } from "./AdvertisingLocalTreeItem.vue?vue&type=template&id=1b0f479a&scoped=true"
import script from "./AdvertisingLocalTreeItem.vue?vue&type=script&lang=js"
export * from "./AdvertisingLocalTreeItem.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingLocalTreeItem.vue?vue&type=style&index=0&id=1b0f479a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f479a",
  null
  
)

export default component.exports